import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import PhoneInput from 'react-phone-input-2';

const relationOptions = ['Self', 'Spouse', 'Child'];

const isOtherValue = (options, value) => {
  return !options.includes(value);
};
const InsuranceDetailsForm = ({
  patientFormData,
  setPatientFormData,
  submeet,
}) => {
  const [otherValue, setOtherValue] = useState('');

  const changeHandler = (e) => {
    setPatientFormData({
      ...patientFormData,
      insuranceDetails: {
        ...patientFormData.insuranceDetails,
        [e.target.name]: e.target.value,
      },
    });
  };

  return (
    <form>
      <div className="card">
        <div className="header">
          <p className="lead">Insurance Details</p>
        </div>
        <div className="body">
          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-12">
              <label>Primary Insurance Company</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.InsuranceCompany === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.InsuranceCompany}
                required
                name="InsuranceCompany"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>

            <div className="form-group col-lg-4 col-md-6">
              <label>Policy Number</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.PolicyNumber === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.PolicyNumber}
                required
                name="PolicyNumber"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
            <div className="form-group col-lg-4 col-md-6">
              <label>Group Number</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.GroupNumber === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.GroupNumber}
                required
                name="GroupNumber"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
          </div>
          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-12">
              <label>Phone Number</label>
              <PhoneInput
                country={'in'}
                value={patientFormData.insuranceDetails.Insurancephone}
                onChange={(homePhone) => {
                  setPatientFormData({
                    ...patientFormData,
                    insuranceDetails: {
                      ...patientFormData.insuranceDetails,
                      Insurancephone: homePhone,
                    },
                  });
                }}
                inputProps={{
                  placeholder: 'Enter your phone number',
                }}
                disableDropdown={false}
                onlyCountries={['in', 'us', 'ca', 'uk']}
                disableCountryCode={false}
              />
              {/* <input
                className={`form-control ${patientFormData.insuranceDetails.Insurancephone === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.Insurancephone}
                required
                name="Insurancephone"
                onChange={(e) => {
                  changeHandler(e);
                }}
              /> */}
            </div>
            <div className="form-group col-lg-4 col-md-12">
              <label>Policy Type</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.policyType === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.policyType}
                required
                name="policyType"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>

            <div
              className="form-group col-lg-4 col-md-12"
              style={{ marginTop: '28px' }}
            >
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label className="input-group-text">
                    Patient's Relationship to Insured
                  </label>
                </div>
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  name="relationship"
                  required
                  defaultValue={'Self'}
                  value={
                    isOtherValue(
                      relationOptions,
                      patientFormData.insuranceDetails.relationship,
                    )
                      ? 'Other'
                      : patientFormData.insuranceDetails.relationship
                  }
                  onChange={changeHandler}
                >
                  {[...relationOptions, 'Other'].map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              {isOtherValue(
                relationOptions,
                patientFormData.insuranceDetails.relationship,
              ) && (
                <input
                  type="text"
                  className="form-control other-text-field"
                  name="relationshipOther"
                  value={patientFormData.insuranceDetails.relationshipOther}
                  onChange={(e) => {
                    setOtherValue(e.target.value);
                    changeHandler(e);
                  }}
                  placeholder="Specify please"
                />
              )}
            </div>
          </div>

          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-6">
              <label>Name of Subscriber (if other than patient)</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.sub === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.sub}
                required
                name="sub"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
          </div>
          <div className="flex col-lg-8 col-md-12 grey-box">
            <div className="form-group col-lg-4 col-md-12">
              <label>Claims Address</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.ClaimAddress === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.ClaimAddress}
                required
                name="ClaimAddress"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
            <div className="form-group col-lg-6 col-md-12">
              <label>State</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.InsuranceState === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.InsuranceState}
                required
                name="InsuranceState"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
            <div className="form-group col-lg-6 col-md-12">
              <label>Zip</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.InsuranceZip === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.InsuranceZip}
                required
                name="InsuranceZip"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>City</label>
              <input
                className={`form-control ${patientFormData.insuranceDetails.InsuranceCity === '' && submeet && 'form-control'}`}
                value={patientFormData.insuranceDetails.InsuranceCity}
                required
                name="InsuranceCity"
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default InsuranceDetailsForm;
